"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PUBLISH_STATUSES;
(function (PUBLISH_STATUSES) {
    PUBLISH_STATUSES["IN_QUEUE"] = "in-queue";
    PUBLISH_STATUSES["INPROGRESS"] = "in-progress";
    PUBLISH_STATUSES["SUCCEEDED"] = "succeeded";
    PUBLISH_STATUSES["UNKNOWN"] = "unknown";
})(PUBLISH_STATUSES = exports.PUBLISH_STATUSES || (exports.PUBLISH_STATUSES = {}));
//# sourceMappingURL=publish-statuses.js.map